import { render, staticRenderFns } from "./CampaignSetup.vue?vue&type=template&id=7631b4ef&scoped=true&"
import script from "./CampaignSetup.vue?vue&type=script&lang=js&"
export * from "./CampaignSetup.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetup.vue?vue&type=style&index=0&id=7631b4ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631b4ef",
  null
  
)

export default component.exports